/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import Collapsible from 'react-collapsible';
import Tramo from './detalle-transporte/tramo';
import TramoPythagoras from './detalle-transporte-pythagoras/paquete-detalle-transporte';
import CityName from '../../../commons/iataRenderService';
import './paquete-checkout-detalle.css';

class Detalle extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      claseDetalle: '',
    });
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { t } = this.props;
    const origen = this.props.paquete.salidas[0].origen !== '' && this.props.paquete.salidas[0].origen !== null ? this.props.paquete.salidas[0].origen : this.props.origen;
    const newTrips = this.props.paquete.salidas[0].transporte.tramos;

    const armarHabitaciones = () => this.props.paquete.salidas[0].hoteles.map((elemento, indice) => {
      return (elemento.tipoHabitacion) ? (
        <div key={indice} style={{ marginBottom: '2%' }} className='noticed-text'>
          {' '}
          {t('checkout.room')}
          {' '}
          {elemento.tipoHabitacion.replace('|', ' ')}
        </div>
      )
        : '';
    });

    const ArmarCantidadMenores = () => {
      let cantidadMenores = 0;
      for (let indice = 0; indice < this.props.habitaciones.length; indice++) {
        cantidadMenores += parseInt(this.props.habitaciones[indice].menores.length);
      }
      if (cantidadMenores > 0) {
        return (
          <div className='noticed-text'>
            {cantidadMenores}
            {' '}
            menores
          </div>
        );
      }
      return '';
    };

    const armarCantidadAdultos = () => {
      let cantidadAdultos = 0;
      for (let indice = 0; indice < this.props.habitaciones.length; indice++) {
        cantidadAdultos += parseInt(this.props.habitaciones[indice].adultos);
      }
      return (
        <div className='noticed-text'>
          {cantidadAdultos}
          {' '}
          adultos
        </div>
      );
    };

    function renderStar(quantity) {
      const stars = [1, 2, 3, 4, 5];

      return stars.map((currentValue) => {
        const className
                    = currentValue <= quantity ? 'fa fa-star yellow' : 'fa fa-star icon-gray';
        return (
          <div className='inline' key={currentValue}>
            <i className={className} aria-hidden='true' />
          </div>
        );
      });
    }

    const armarHoteles = () => this.props.paquete.salidas[0].hoteles.map((hotel, indice) => {
      const tipoHabitacion = (hotel.tipoHabitacion) ? (
        <span className='tramo-title' style={{ display: 'inline-block' }}>
          Hab.
          {hotel.tipoHabitacion.replace('|', ' ')}
        </span>
      ) : '';
      const noches = (hotel.noches) ? hotel.noches + (hotel.noches > 1) ? 'noches' : 'noche' : '';
      const regimen = (hotel.regimen) ? <span className='regimen'>{hotel.regimen}</span> : '';
      return (
        <ul key={indice} className='list-unstyled hotel'>
          <li className='noticed-text-color'>
            {hotel.nombre}
            {' '}
            {renderStar(hotel.clase)}
          </li>
          <li className='plain-text'>
            {noches}
            {' '}
            {regimen}
            {' '}
            {tipoHabitacion}
          </li>
        </ul>
      );
    });

    let tramos = newTrips.map((trip) => (
      <Tramo
        key={`trip-${trip.id}`}
        direccion={trip.tripTypeId}
        escalas={trip.stops}
        tramo={trip}
      />
    ));

    if (this.props.paquete.salidas[0].transporte.transporteAereo !== null) {
      if (this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo !== null) {
        // No borrar el IF, Si no muere pythagoras!
        tramos = this.props.paquete.salidas[0].transporte.transporteAereo !== null
          ? (
            <div>
              <Tramo
                direccion={t('checkout.trip')}
                escalas={this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeIda.escalas}
                tramo={this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeIda.segmentoPrincipal}
              />
              <Tramo
                direccion={t('checkout.trip')}
                escalas={this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeVuelta.escalas}
                tramo={this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeVuelta.segmentoPrincipal}
              />
            </div>
          )
          : '';
      }
    }

    // Si es Pythagoras
    const { proveedorId } = this.props.paquete;
    if (proveedorId >= 5 && proveedorId <= 9) {
      const ciudadOrigen = <CityName code={this.props.paquete.salidas[0].origenIata} upperCase='true' />;
      const ciudadDestino = <CityName code={this.props.paquete.salidas[0].destinoIata.split(';')[1]} upperCase='true' />;
      tramos = <TramoPythagoras origen={ciudadOrigen} destino={ciudadDestino} salida={this.props.paquete.salidas[0]} />;
    }

    const titulo = ReactHtmlParser(
      parseInt(this.props.paquete.proveedorId) === 10
        ? this.props.paquete.nombre.replace(/\((.*?)\)/g, '')
        : this.props.paquete.nombre,
    );

    const noches = `${(this.props.paquete.cantNoches.toString()) + ((this.props.paquete.cantNoches > 1) ? ` ${t('filters.nightW')} ` : ` ${t('filters.nightWs')} `)}`;

    const salida = moment(this.props.paquete.salidas[0].fechaSalida).format('DD/MM/YYYY');

    const mobile = window.innerWidth <= 768;
    const acordionTitle = () => {
      return (
        <div className='select-none font-bold text-xl divide-y pb-3 text-gray-500 titulo-acordion'>{t('checkout.details')}</div>
      );
    };
    return (
      <div className='container bg-white my-4 p-6'>

        <Collapsible open={true} trigger={acordionTitle()}>

          <h3 className='titulo-paquete pt-2'>{titulo}</h3>
          <h4 className='noticed-text'>{noches}</h4>
          <div className='plain-text'>
            {t('packages.departure')}
            {' '}
            {salida}
          </div>
          <div className='plain-text'>
            {t('packages.from')}
            {' '}
            {origen}
          </div>
          {armarHabitaciones()}
          {armarCantidadAdultos()}
          {ArmarCantidadMenores()}
          <hr />
          <div className='noticed-text'>{t('checkout.hotels')}</div>
          {armarHoteles()}
          <hr style={{ margin: '13px 0' }} />

          <div className='noticed-text'>{t('checkout.transport')}</div>
          {tramos !== '' && tramos}
          <hr style={{ margin: '13px 0' }} />

          <div className='noticed-text'>
            <div className='plain-text'>{t('checkout.includes')}</div>
            {ReactHtmlParser(this.props.paquete.metaDescripcion)}
          </div>
        </Collapsible>
      </div>
    );
  }
}

export default withTranslation(['translations'])(Detalle);
